/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo tooltip
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var Tooltip = kendo.ui.Tooltip;
    if (!Tooltip || Tooltip.updated) return;

    var NS = ".kendoTooltip",
        DATA = "kendoTooltip",
        proxy = $.proxy,
        DOCUMENT = $(document),
        ID = "id",
        ARIAIDSUFFIX = "_tt_active",
        DESCRIBEDBY = "aria-describedby",
        POINTER_DOWN = "pointerdown",
        CENTER = "center",
        REVERSE = {
            "top": "bottom",
            "bottom": "top",
            "left": "right",
            "right": "left",
            "center": "center"
        },
        DIRCLASSES = {
            bottom: "n",
            top: "s",
            left: "e",
            right: "w",
            center: "n"
        },
        POSITIONS = {
            bottom: {
                origin: "bottom center",
                position: "top center"
            },
            top: {
                origin: "top center",
                position: "bottom center"
            },
            left: {
                origin: "center left",
                position: "center right",
                collision: "fit flip"
            },
            right: {
                origin: "center right",
                position: "center left",
                collision: "fit flip"
            },
            center: {
                position: "center center",
                origin: "center center"
            }
        },
        ATTR_TITLE = "title";

    /**
     * Helper function for applying / updating Kendo tooltip on a given element.
     * Applies the tooltip only on first targeted element.
     * TODO : add tooltip themes and max sizes
     * TODO : add dynamic positioning of tooltip callout ( limit to object )
     * TODO : investigate and solve problems with tooltip animation
     */
    function applyTooltip(element, options) {
        var $element = $(element);
        var tooptipHolderClickHandler = function (event) {
            tooltip.toggle($first);
        }
        if (!$element.length) return undefined;
        options = options || {};
        var $first = $element.first(),
            tooltip = $first.data(DATA);
        if (!tooltip) {
            tooltip = $first.kendoTooltip(options).data(DATA);
            $first.on(POINTER_DOWN + NS, tooptipHolderClickHandler);
        }
        else {
            if (!options.content) options.content = tooltip.options.content;
            tooltip.update(options, true); // TODO : depends on updated kendo tooltip
        }

        return tooltip;
    }

    /**
     * Validation & tooltip message popups on mouse over.
     */
    function applyElementTooltips(elements, options) {
        var $elements = $(elements),
            duration = 0, // options.duration || 0; // TODO : problems with Kendo animation so far
            opt = $.extend({
                // autoHide : false, // TODO : for testing
                animation: {
                    open: { effects: "fade:in", duration: duration },
                    close: { effects: "fade:out", duration: duration }
                }
            }, options);
        $elements.each(function (index, element) {
            // had to take the original jQuery reference as kendo.jQuery.isReady
            // doesn't get updated after DOM ready
            if (jQuery.isReady)
                applyTooltip(element, opt);
            else
                $(function () { applyTooltip(element, opt); });
        });
    }

    /**
     * Helper function for removing Kendo tooltip from a given element.
     * Works only only for first targeted element.
     */
    function removeTooltip(element) {
        var $element = $(element);
        if (!$element.length) return;
        var $first = $($element[0]),
            tooltip = $first.data(DATA);
        if (!tooltip) return;
        tooltip.destroy(); // also seems to destroy the DOM markup properly
        $first.off(POINTER_DOWN + NS);
    }

    /**
     * Removes tooltip functionality from specified elements.
     */
    function removeElementTooltips(elements) {
        var $elements = $(elements);
        $elements.each(function (index, element) {
            if (jQuery.isReady)
                removeTooltip(element);
            else
                $(function () { removeTooltip(element); });
        });
    }

    function restoreTitleAttributeForElement(element) {
	    var title = element.data(kendo.ns + "title");
	    if (title) {
	        element.attr("title", title);
	        element.removeData(kendo.ns + "title");
	        return true;
	    }
	}

    function restoreTitle(element) {
	    while(element.length) {
	        if (restoreTitleAttributeForElement(element)) {
	            break;
	        }
	        element = element.parent();
	    }
	}

    /**
     * Some delay is needed on mouse leave in some cases before the tooltip gets
     * hidden. So we override mouseleave event handler here.
     */
    function tooltipMouseLeave(event) {
        var self = this,
            $element = $(event.currentTarget);
        clearTimeout(self.timeout);
        if (!self.popup) {
            restoreTitle($element);
            return;
        }
        var offset = $element.offset(),
            pageX = event.pageX,
            pageY = event.pageY;
        offset.right = offset.left + $element.outerWidth();
        offset.bottom = offset.top + $element.outerHeight();
        if (
            pageX > offset.left && pageX < offset.right &&
            pageY > offset.top && pageY < offset.bottom
        ) return;
        clearTimeout(self.hideTimeout);
        var t = self.options.delay || 0;
        self.hideTimeout = setTimeout(function () {
            self.popup.close.apply(self.popup);
        }, t);
    }

    /**
     * Almost the same functionality as in original method for now.
     * Difference - self.popup = new kendo.ui.Popup() - instantiates overriden
     * object with new methods.
     * TODO : better way ?
     */
    function tooltipInitPopup() {
        var self = this,
            options = self.options,
            TEMPLATE =
                '<div role="tooltip" class="k-widget k-tooltip#if (!autoHide) {# k-tooltip-closable#}##if( skin ) { # #= skin ## } #">' +
                '#if (!autoHide) {# <div class="k-tooltip-button"><a href="\\#" class="k-icon k-i-close">close</a></div> #}#' +
                '<div class="k-tooltip-content"></div>' +
                '#if (callout){ #<div class="k-callout k-callout-#=dir#"></div>#}#' +
                '</div>',
            $wrapper = $(kendo.template(TEMPLATE)({
                callout: options.callout && options.position !== CENTER,
                dir: DIRCLASSES[options.position],
                autoHide: options.autoHide,
                skin: options.skin
            })),
            CSS_OPTIONS = ["width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight"];
        self.popup = new kendo.ui.Popup(
            $wrapper,
            // popup options
            $.extend(
                true,
                {
                    activate: function () {
                        var anchor = this.options.anchor,
                            ariaId = anchor[0].id || self.element[0].id;
                        if (ariaId) {
                            anchor.attr(DESCRIBEDBY, ariaId + ARIAIDSUFFIX);
                            this.element.attr(ID, ariaId + ARIAIDSUFFIX);
                        }
                        if (options.callout) self._positionCallout();
                        this.element.removeAttr("aria-hidden");
                        DOCUMENT.on("keydown" + NS, self._documentKeyDownHandler);
                        self.trigger("show");
                    },
                    close: function () { self.trigger("hide"); },
                    copyAnchorStyles: false,
                    animation: options.animation
                },
                POSITIONS[options.position],
                // transfer some of tooltip options into popup ( offset etc. )
                {
                    offset: options.offset,
                    viewport: options.viewport,
                    autoSize: options.autoSize,
                    skin: options.skin,
                    appendTo: options.appendTo
                }
            )
        );
        // set CSS options on tooltip wrapper
        var css = {};
        for (var i = 0; i < CSS_OPTIONS.length; i++)
            css[CSS_OPTIONS[i]] = options[CSS_OPTIONS[i]];
        $wrapper.css(css);
        self.content = $wrapper.find(".k-tooltip-content");
        self.arrow = $wrapper.find(".k-callout");
        if (options.autoHide)
            $wrapper
                .on("mouseenter" + NS, function () { clearTimeout(self.hideTimeout); })
                .on("mouseleave" + NS, proxy(tooltipMouseLeave, self));
        else
            $wrapper.on("click" + NS, ".k-tooltip-button", proxy(self._closeButtonClick, self));
    }

    /**
     * Adds toggle() method to Kendo tooltip.
     */
    function tooltipToggle(target) {
        var self = this,
            $target = $(target);
        self[(self.popup && self.popup.visible()) ? "hide" : "show"]($target);
    }

    /**
     * Updates given instance of tooltip with given options.
     */
    function tooltipUpdate(options, takeElementOptions) {
        var self = this,
            $element = $(self.element);
        if (takeElementOptions && $element.length)
            options = kendo.elementOptions($element, "tooltip", options);
        options = $.extend(true, self.options, options);
        // put title into content option as last resort
        if (typeof options.content == "function" && !options.content({ target: $element })) {
            var title = $element.attr(ATTR_TITLE);
            if (title) options.content = title;
        }
        self.setOptions(options);
        self.refresh();
        self.info("Refreshed tooltip with options : %o.", self.options);
    }

    /**
     * Repositioning callout arrow according to updated design. Was updated with
     * top border width before, but this can be 0 now, so have to see actual
     * borders applied.
     * TODO : position tooltip content according to control when required.
     */
    function tooltipPositionCallout() {
        var self = this,
            position = self.options.position,
            dimensions = self.dimensions,
            offset = dimensions.offset,
            popup = self.popup,
            anchor = popup.options.anchor,
            anchorOffset = $(anchor).offset(),
            elementOffset = $(popup.element).offset(),
            cssClass = DIRCLASSES[popup.flipped ? REVERSE[position] : position],
            borderPropertyNames = {
                "n": "border-left-width",
                "s": "border-left-width",
                "e": "border-top-width",
                "w": "border-top-width"
            },
            arrowBorder = parseInt(self.arrow.css(borderPropertyNames[cssClass]), 10),
            offsetAmount = anchorOffset[offset] - elementOffset[offset] +
                ($(anchor)[dimensions.size]() / 2) - arrowBorder;
        self.arrow
            .removeClass("k-callout-n k-callout-s k-callout-w k-callout-e")
            .addClass("k-callout-" + cssClass)
            .css(offset, offsetAmount | 0);
        self.info("Updated callout position - class : 'k-callout-%s', %s : %s.", cssClass, offset, offsetAmount);
    }

    /**
     * On show we have to clear the hide timeout when set.
     */
    function tooltipShow(target) {
        var self = this,
            newPopupCreated = false,
            current = self.target();
        if (self.hideTimeout) clearTimeout(self.hideTimeout);
        if (!self.popup) {
            self._initPopup();
            newPopupCreated = true;
            self.info(
                "Created new popup : %o, content element : %s.",
                self.popup, self.describeElement(self.popup.element)
            );
        }
        if (current && current[0] !== target[0]) {
            self.popup.close();
            // animation can be too long to hide the element before it is shown again
            self.popup.element.kendoStop(true, true);
        }
        if (!current || current[0] !== target[0]) {
            self._appendContent(target);
            self.popup.options.anchor = target;
        }
        self.popup.one("deactivate", function () {
            restoreTitle(target);
            target.removeAttr(DESCRIBEDBY);
            self.element
                .removeAttr(ID)
                .attr("aria-hidden", true);
            DOCUMENT.off("keydown" + NS, self._documentKeyDownHandler);
        });
        // fixing bug on mobile
        // setTimeout( function() {
        self.info(
            "Opening tooltip popup : %o, content element : %s.",
            self.popup, self.describeElement(self.popup.element)
        );
        if (newPopupCreated) self.popup.position();
        self.popup.open();
        // } );
    }

    // publish needed methods into global kendo namespace
    $.extend(true, kendo, {
        applyTooltip: applyTooltip,
        applyElementTooltips: applyElementTooltips,
        removeTooltip: removeTooltip,
        removeElementTooltips: removeElementTooltips
    });

    /**
     * The original widget "class" gets updated in two steps. First is constructor
     * update. newInit function becomes the new constructor of the component.
     * In the constructor the widget is also republished as kendo plugin, so that
     * jQuery.fn gets updated. Second step is overriding of specific widget methods
     * when needed.
     */
    var oldTooltipInit = Tooltip.fn.init,
        newTooltipInit = function (element, options) {
            var self = this,
                $element = $(element);
            // update options from specifically prefixed data on element
            options = kendo.elementOptions($element, "tooltip", options);
            // call original constructor
            oldTooltipInit.call(self, element, options);
            // TODO : not very nice with the direct pointer to
            // tooltipMouseLeave; should be rather self._mouseleave,
            // but here we do not have the method updated yet, so
            // rather have the updateMethods configured in 2 steps ?
            if (self.options.autoHide)
                self.element
                    .off("mouseleave" + NS)
                    .on("mouseleave" + NS, self.options.filter, proxy(tooltipMouseLeave, self));
        };

    Tooltip = Tooltip.extend({
        // new init
        init: newTooltipInit,
        // default options extension
        options: kendo.getUpdatedWidgetOptions({
            offset: 10
        }),
        // updated methods
        toggle: tooltipToggle,
        update: tooltipUpdate,
        _show: tooltipShow,
        _positionCallout: tooltipPositionCallout,
        _initPopup: tooltipInitPopup
    });

    Tooltip.updated = true;

    kendo.ui.plugin(Tooltip);

})(window.kendo.jQuery);
